import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { AppIcon } from '@tablesready/frontend-icons';

export interface RouteHeaderData {
  title: string;
  badgeCount: number;
}

export interface RouteHeaderAction {
  id: string;
  onClick: () => void;
  title: string;
  icon?: AppIcon;
}

export interface RouteHeaderActions {
  groupName: string;
  initiallyActiveId: string;
  actions: RouteHeaderAction[];
}

@Injectable()
export class HeaderTitleService {
  data$: Observable<Record<string, Partial<RouteHeaderData>>>;

  private lastData: Record<string, Partial<RouteHeaderData>> = {};

  private readonly dataSource$ = new BehaviorSubject<Record<string, Partial<RouteHeaderData>>>(this.lastData);

  constructor() {
    this.data$ = this.dataSource$.asObservable();
  }

  setDataForRoute(routeId: string, data: Partial<RouteHeaderData>): void {
    this.lastData[routeId] = {
      ...this.lastData[routeId],
      ...data,
    };

    this.dataSource$.next(this.lastData);
  }
}
